import * as React from 'react';
import * as analytics from '../../../../analytics';
import { bindActionCreators } from 'redux';
import { IControlConfiguration, ISectionUIControlProps } from "../../interfaces/ISectionUIControlProps";
import {
    Selection, arraysEqual, DefaultButton, CheckboxVisibility, IContextualMenuItem, MessageBar, MessageBarType, TooltipHost, TooltipDelay, Icon, memoizeFunction
} from 'office-ui-fabric-react';
import { IListProps } from '../../extensibleEntity/EntityDetailsList';
import * as ResourcesListStore from '../../../../store/ResourcesListStore';
import * as PortfoliosListStore from '../../../../store/PortfoliosListStore';
import * as ProgramsListStore from '../../../../store/ProgramsListStore';
import * as ProjectsListStore from '../../../../store/ProjectsListStore';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../../store';
import * as Metadata from '../../../../entities/Metadata';
import AddEntitiesDialog from "./projectsControl/AddEntitiesDialog";
import {
    Dictionary, EntityType, IColumn, IExtensibleEntity, ITimeframe, IWithResourcePlan, IWithWarnings, SortDirection, updateCheckboxOptions, entityTypeLabelMap, IScalableTimeframe, IEditable, EstimatedChargeCalculationMode
} from "../../../../entities/common";
import { ControlSpiner } from '../../Spinner';
import { isInReadonlyMode, UserState } from '../../../../store/User';
import { CommonOperations, canCreateResource, canResourceAnyRead, canResourcePlanAnyUpdate, contains, noneForResourceEntity } from '../../../../store/permissions';
import {
    TotalUsageCell, AssignmentsTotalCell, allocationWarning, hasOutsideAllocation, calculateResourcePlanSummaryData, calculateAssignmentsSummaryData
} from '../../../resource/usage/ResourceUsageCell';
import { timeTypesConfigMap, CellSummaryContext } from '../../../resource/usage/ResourceUsageCell/common';
import {
    assignmentTimeTypesConfigMap, buildAssignmentsTotalFields, ProjectAssignments, ServerProjectAssignments, toProjectAssignments
} from '../../../resource/usage/assignments';
import { ResourceTimelineGroup } from '../../ViewTypeSelect';
import UtilizationTooltipContent from '../../../resource/usage/UtilizationTooltipContent';
import AssignmentsTooltipContent from '../../../resource/usage/AssignmentsTooltipContent';
import TotalTooltipContent from '../../../resource/usage/totalTooltipContent';
import { SectionControlPlaceholder } from '../SectionPlaceholder';
import RemoveDialog from '../../RemoveDialog';
import ResourceCreationInResourcePlanControl from '../../../resource/ResourceCreationInResourcePlanControl';
import PersonPickerInput from '../../inputs/PersonPickerInput';
import { filter, notUndefined, toDate, waitForFinalEvent } from '../../../utils/common';
import {
    defaultTimeframe, ViewType, IMaybeTotal, totalRow, PersistResourceUsageGrid,
    ResourceUsageGridSettings, OnUsageGridSaveSettings
} from '../../../resource/usage/ResourceUsageGrid';
import { nameof } from '../../../../store/services/metadataService';
import { ITimelineProps } from '../../extensibleEntity/EntityTimelineList';
import { IRow } from '../../timeline/TimelineList';
import { PPMFeatures, Subscription } from '../../../../store/Tenant';
import ReplaceResourceDialog from '../../../resource/ReplaceResourceDialog';
import { ViewService } from '../../../../services/ViewService';
import { IWithActiveFilter, getTimeframe } from '../../../../store/services/viewSaver';
import {
    calculateStateInEntity, convertToDateOnlyTimeframe, totalsFieldIds, calculateResourceUsageGridField as calculate, buildResourcePlanCalculatedFields,
    CalculatedFieldFormatter
} from '../../../resource/usage/ResourceUsageGrid/BaseResourceUsageGrid';
import { EnableCalculatingResourcePlanActualsBasedOnReportedTime } from '../../../timeTracking/TimeTrackingGrid';
import { buildActionsMenuItemWithItems, buildExtensionsMenuItem } from '../../headerMenuItemBuilders';
import { ExtensionInfo, ExtensionPageLocation, findExtension } from '../../../../store/ExtensionStore';
import ExtensionPanel from '../../ExtensionPanel';
import { IWithSearch, isSearchChanged, withSearch } from '../../withSearch';
import { IWithFilter, WithFilterProps, withFilter } from '../../withFilter';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as FiltersStore from '../../../../store/filters';
import { FilterHelper } from '../../../../store/resource/filters';
import { SearchFieldService } from '../../SearchFieldService';
import { ConfirmationDialog } from '../../ConfirmationDialog';
import { PersonInfo } from '../../../../store/UsersListStore';
import { cancellableGet, post } from '../../../../fetch-interceptor';
import { CancelTokenSource } from 'axios';
import { defaultCatch } from '../../../../store/utils';
import * as NotificationsStore from '../../../../store/NotificationsStore';
import { getDefaultCostRateTable } from '../../../../store/selectors/costRateTableSelectors';
import { FieldsState } from '../../../../store/fields';
import * as CostRateTableStore from '../../../../store/CostRateTableStore';
import { onScaleChanged } from '../../../resource/usage/ResourceUsageGrid/BaseUsageGrid';
import { ResourcePlanResourceName } from '../../../resource/usage/ResourcePlanResourceName';
import { ResourceLoadingTypes } from '../../../../store/ResourcesListStore';

export interface IDataContext {
    entityType: EntityType;
}

export interface IActions {
    addResources: (resourceIds: string[], timeframe: IScalableTimeframe) => void;
    replaceResources: (prevId: string, nexId: string, keepRate: boolean, sumUpPlanHours: boolean, sumUpActualHours: boolean, timeframe: IScalableTimeframe, costRateTableId?: string) => void;
    removeResources: (resourceIds: string[], timeframe: IScalableTimeframe) => void;
    createResource: (name: string, layoutId: string, timeframe: IScalableTimeframe, auto?: boolean, startDate?: Date, finishDate?: Date) => void;
    updateUIControl: (sectionId: string, uiControlId: string, settings: Dictionary<any>) => void;
}

interface ISettings {
    displayFields: string[];
    orderBy: string[];
    timeline: {
        displayFields: string[];
    };
    assignments: {
        displayFields: string[];
    };
}

type ControlSettings = {
    timelineGroup: ResourceTimelineGroup,
    viewType: ViewType,
    assignments?: { timeType?: ResourceUsageGridSettings['timeType'] }
} & ResourceUsageGridSettings & IWithActiveFilter;
export type IConfiguration = IControlConfiguration<IActions, ControlSettings, IDataContext>
type OwnProps = ISectionUIControlProps<IActions, ISettings, IExtensibleEntity & IWithResourcePlan, {}, ControlSettings, IDataContext> & IWithSearch;

type StoreProps = {
    resources: ResourcesListStore.ResourcesState,
    fields: Metadata.Field[];
    fakeFields: Metadata.Field[];
    isFieldsLoading: boolean;
    user: UserState;
    extensions: ExtensionInfo[];
    layouts: Metadata.Layout[];
    canManageConfiguration: boolean;
    canConfigureSelection: boolean;
    hasPortfolioManagement: boolean;
    hasProjectManagement: boolean;
    hasResourceRoles: boolean;
    isListLoading: boolean;
    enableCalculatingResourcePlanActualsBasedOnReportedTime: boolean;
    defaultCostRateTableId?: string;
    fieldsStore?: Record<string, FieldsState>;
    costRateTables: CostRateTableStore.CostRateTableState;
}

type ActionProps = {
    portfoliosActions: typeof PortfoliosListStore.actionCreators;
    programsActions: typeof ProgramsListStore.actionCreators;
    projectsActions: typeof ProjectsListStore.actionCreators;
    resourceActions: typeof ResourcesListStore.actionCreators;
    notificationsActions: typeof NotificationsStore.actionCreators
    filtersActions: ReturnType<typeof FiltersStore.actionCreators.forEntity>;
}

type Props = OwnProps & StoreProps & ActionProps & RouteComponentProps<{}> & IWithFilter<ResourcesListStore.Resource>;

interface State {
    resources: ResourcesListStore.Resource[];
    filteredResources: ResourcesListStore.Resource[];
    selectedResourceIds: string[];
    isAllocateAccessRequest: boolean;
    isAdding: boolean;
    isCreating: boolean;
    isReplacing: boolean;
    isRemoving: boolean;
    canReplace: boolean;
    timeframe: ITimeframe;
    isResourcePlanActualsSyncInProgress: boolean;
    isOpenExtensionPanel?: ExtensionInfo;
    assignments?: Dictionary<ProjectAssignments>;
    isLoadingAssignments: boolean;
}

type WithEstimatedChargeSettings = {
    settings?: {
        estimatedChargeCalculationMode?: EstimatedChargeCalculationMode;
    }
};

const debounceDelay = 400;

//is shown from entity: Project, Idea, Portfolio, Program
class ResourcePlanControl extends React.Component<Props, State> {
    private _rowSelection: Selection;
    private _debouncedLoadUsages: () => void;
    private _debouncedLoadAssignments: (resourceIds: string[], timeframe: IScalableTimeframe) => void;
    private _assignmentsCancelTokenSource?: CancelTokenSource;

    constructor(props: Props) {
        super(props);

        this._rowSelection = new Selection({
            onSelectionChanged: () => { this.setState({ selectedResourceIds: this._rowSelection.getSelection().map(_ => (_ as ResourcesListStore.Resource).id) }); },
            getKey: (item) => (item as IExtensibleEntity).id
        });

        const { entity } = props;

        entity.resourceIds.length && props.resourceActions.loadResourcesByIds(entity.resourceIds, ResourceLoadingTypes.Usages);
        const resources = this._getResources(props, undefined);

        this.state = {
            resources,
            filteredResources: getFilteredResources(resources, props, entity.id),
            selectedResourceIds: [],
            isAllocateAccessRequest: false,
            isAdding: false,
            isCreating: false,
            isReplacing: false,
            isRemoving: false,
            canReplace: false,
            timeframe: defaultTimeframe,
            isResourcePlanActualsSyncInProgress: false,
            isLoadingAssignments: false
        };

        this._debouncedLoadUsages = waitForFinalEvent((resourceIds, timeframe) =>
            this.props.resourceActions.loadUsages(resourceIds, timeframe, this.props.entity.isArchived), debounceDelay, 'resouce-plan');
        this._debouncedLoadAssignments = waitForFinalEvent((_, timeframe) => this._loadProjectAssignments(timeframe), debounceDelay, 'resource-plan-assignments');
    }

    componentWillMount() {
        if (this._isAssignments(this.props)) {
            this._loadAssignments(this.props);
        }
        if (this.props.hasPortfolioManagement) {
            this.props.portfoliosActions.requestPortfolios();
            this.props.programsActions.requestPrograms();
        }
        if (this.props.hasProjectManagement) {
            this.props.projectsActions.requestProjects();
        }
    }

    componentWillUnmount() {
        this._assignmentsCancelTokenSource?.cancel();
    }

    componentWillReceiveProps(nextProps: Props) {
        const nextEntity = nextProps.entity;
        const entity = this.props.entity;

        const prevMode = (entity as IExtensibleEntity & WithEstimatedChargeSettings).settings?.estimatedChargeCalculationMode;
        const nextMode = (nextEntity as IExtensibleEntity & WithEstimatedChargeSettings).settings?.estimatedChargeCalculationMode;
        if (prevMode !== nextMode) {
            const timeframe = convertToDateOnlyTimeframe(this._getTimeframe());
            nextEntity.resourceIds.length && this.props.resourceActions.loadUsages(nextEntity.resourceIds, timeframe, nextEntity.isArchived);
        }

        if (!arraysEqual(entity.resourceIds, nextEntity.resourceIds)) {
            const notLoaded = nextEntity.resourceIds.filter(_ => !~entity.resourceIds.indexOf(_));
            const timeframe = convertToDateOnlyTimeframe(this._getTimeframe());
            notLoaded.length && this.props.resourceActions.loadResourcesByIds(notLoaded, ResourcesListStore.ResourceLoadingTypes.Usages, timeframe);
        }

        if (this._isAssignments(nextProps) && !this._isAssignments(this.props)) {
            this._loadAssignments(nextProps);
        }

        const nextResources = this._getResources(nextProps, this.state.assignments);
        if (!arraysEqual(this.state.resources, nextResources) || isSearchChanged(this.props, nextProps)
            || this.props.filter.isItemVisible !== nextProps.filter.isItemVisible
            || this.props.resources.isListLoading && !nextProps.resources.isListLoading) {
            this.setState({
                resources: nextResources,
                filteredResources: getFilteredResources(nextResources, nextProps, entity.id)
            });
        }
    }

    public render() {
        const { user, entity, fields, settings, fakeFields, isFieldsLoading, canConfigureSelection, controlSettings, onSaveSettings } = this.props;
        const { isAllocateAccessRequest, isAdding, isCreating, isRemoving, isReplacing, resources, filteredResources, timeframe, selectedResourceIds } = this.state;
        const { entityType } = this.props.datacontext;
        const isAssignments = this._isAssignments(this.props);
        const rowIds = this._getRowIds(this.props, this.state.assignments);
        const isEmpty = !rowIds.length && (!isAssignments || !!this.state.assignments);
        const projectTotalsFields = buildProjectTotalsFields(this.state.assignments);

        if (isFieldsLoading || (this.props.resources.isListLoading && !filteredResources.length)) {
            return <ControlSpiner isLoading={true} />;
        }

        const canCreate = canCreateResource(user.permissions.resource);
        const canAnyResourcePlanUpdate = canResourcePlanAnyUpdate(user.permissions.resource);
        const readOnly = !entity.isEditable || !canAnyResourcePlanUpdate;
        const gridReadOnly = readOnly || isAssignments;
        const autoallocationTimeframe = entity.attributes.StartDate && entity.attributes.FinishDate
            ? { start: toDate(entity.attributes.StartDate)!, end: toDate(entity.attributes.FinishDate)! }
            : timeframe;

        const selectionModeCommands = this._getSelectionModeCommands(gridReadOnly);
        const hasHiddenResources = filteredResources.length !== resources.length;
        const listProps: IListProps & Partial<ITimelineProps> = {
            buildTree: true,
            showTreeExpandColumn: false,
            selection: this._rowSelection,
            entities: [totalRow],
            entityType: EntityType.Resource,
            fields: fields.concat(fakeFields),
            isFieldFake: field => this.props.fakeFields.some(_ => _.id == field.id),
            displayFields: canResourceAnyRead(user.permissions.resource) //server retuns only names if cannot read
                ? (isAssignments ? settings.assignments : settings.timeline).displayFields
                : [nameof<ResourcesListStore.ResourceAttrs>("Name")],
            renderHeaderCellContent: hasHiddenResources ? renderPartialTotalsColumnHeader : undefined,
            onItemRender: (resource: ResourcesListStore.Resource & IMaybeTotal, _, field, defaultRender) => {
                const totalsField = projectTotalsFields.find(__ => __.id === field.id);
                if (totalsField) {
                    return <CalculatedFieldFormatter calculatedField={totalsField} formatType={totalsField.settings!.format} user={user}
                        resources={this.props.resources} entityIds={[entity.id]} resourceIds={resource.isTotal ? filteredResourcesIds : [resource.id]}
                        className={resource.isTotal ? 'usage-total' : undefined} />;
                }
                if (resource.isTotal) {
                    return <></>;
                }
                if (field.name === nameof<ResourcesListStore.ResourceAttrs>("Name")) {
                    return <ResourcePlanResourceName resource={resource} entityId={entity.id} />;
                }
                return defaultRender();
            },
            expandedEntitiesIds: [totalRow.id],
            primaryOutlineLevel: 1,
            buildRow: _ => buildResourcesGroup(_, entity, filteredResources, entityType),
            isArchived: entity.isArchived,
            ...updateCheckboxOptions({ checkboxVisibility: gridReadOnly ? CheckboxVisibility.hidden : undefined }, selectionModeCommands, !gridReadOnly)
        };

        const filteredResourcesIds = this.state.filteredResources.map(_ => _.id);

        return <>
            {!isAssignments && entity.isEditable && !canAnyResourcePlanUpdate && <MessageBar isMultiline={true} messageBarType={MessageBarType.warning}>
                The Resource Plan cannot be edited because you do not have permission to manage it. Please contact your administrator to request the necessary permissions.
            </MessageBar>}
            {isEmpty
                ? <SectionControlPlaceholder
                    iconName="PPMXSectionResourcePlan"
                    title={`${this.props.sectionLabel} section is empty`}
                    description={`Resources have not been added to the ${entityTypeLabelMap[entityType].singular} yet`}>
                    {
                        !gridReadOnly &&
                        <>
                            <DefaultButton
                                text="Add Resources"
                                onClick={() => this.setState({ isAdding: true })} />
                            {
                                canCreate && <DefaultButton
                                    text="Create Resource"
                                    onClick={() => this.setState({ isCreating: true })} />
                            }
                        </>
                    }
                </SectionControlPlaceholder>
                : <PersistResourceUsageGrid
                    entitiesMap={{ [entity.id]: entity }}
                    entityType={entityType}
                    commitDisabled={entityType === EntityType.Idea || entity.isPrivate}
                    actualTimeDisabled={entityType === EntityType.Idea}
                    onTimeframeChanged={_ => this.setState({ timeframe: _ })}
                    menuProps={{
                        fields: listProps.fields,
                        type: "Columns",
                        entityType: entityType,
                        search: this.props.search,
                        isFieldFake: listProps.isFieldFake,
                        mandatoryViewFields: ViewService.getViewMandatoryFields(entityType),
                        displayFields: listProps.displayFields,
                        canViewConfigureColumns: canConfigureSelection,
                        onDisplayFieldsChange: canConfigureSelection ? this._onTimelineDisplayFieldsChange : undefined,
                        commands: this._getCommands(readOnly, canCreate, isAssignments),
                        selectionMode: {
                            enabled: selectedResourceIds.length > 0,
                            items: selectionModeCommands,
                            onCancel: () => this._rowSelection.setAllSelected(false)
                        },
                        ...this.props.filter.menu,
                        onAddFilterClick: undefined,
                        onEditFilterClick: undefined,
                        onRemoveFilterClick: undefined,
                        onCopyFilterClick: undefined
                    }}
                    listProps={listProps}
                    selectedEntityIds={selectedResourceIds}
                    isLoading={this.props.resources.isListLoading || this.props.resources.isLoading || this.props.resources.isLoadingUsage
                        || (isAssignments && this.state.isLoadingAssignments)}
                    entitiesIds={rowIds}
                    extractRowIds={(_: IExtensibleEntity & IMaybeTotal) => ({
                        entityIds: [entity.id], resourceIds: _.isTotal ? filteredResourcesIds : [_.id], isTotalRow: _.isTotal
                    })}
                    extractCellIds={cell => ({ entityId: entity.id, resourceId: cell.entityId })}
                    viewType={this.props.controlSettings.viewType}
                    timeTypesConfig={isAssignments ? assignmentTimeTypesConfigMap : timeTypesConfigMap}
                    cellSummaryCalculator={isAssignments ? buildAssignmentsSummaryCalculator(this.state.assignments) : calculateResourcePlanSummaryData}
                    calculatedFields={isAssignments ? projectTotalsFields : buildResourcePlanCalculatedFields(entityType, entity.isArchived)}
                    renderTotalSegmentContent={(_, segment, timeType) => isAssignments
                        ? <AssignmentsTotalCell resources={filteredResources} assignments={this.state.assignments} startDate={segment.startDate} finishDate={segment.finishDate}
                            timeType={timeType} viewType={this.props.controlSettings.viewType ?? ViewType.Hours} entityType={entityType} />
                        : <TotalUsageCell resources={filteredResources} entityIds={[entity.id]} startDate={segment.startDate} finishDate={segment.finishDate}
                            timeType={timeType} viewType={this.props.controlSettings.viewType ?? ViewType.Hours} entityType={entityType} />
                    }
                    renderCellTooltip={props => isAssignments
                        ? <AssignmentsTooltipContent {...props} byDay={this.state.assignments?.[props.resource.id]?.byDay} />
                        : <UtilizationTooltipContent {...props} showPerEntityWork />}
                    renderTotalTooltip={props => isAssignments ? undefined : <TotalTooltipContent {...props} />}
                    isEditable={gridReadOnly ? undefined : (item: ResourcesListStore.Resource & IMaybeTotal) => this._isPlanEditable(item)}

                    buildRowMenuItems={isAssignments ? undefined : (item: ResourcesListStore.Resource & IMaybeTotal) => readOnly || !this._isPlanEditable(item)
                        ? this._BuildAllocationRequestMenuItems(item)
                        : [
                            selectedResourceIds.length === 1 ? {
                                key: 'replace',
                                name: 'Replace Resource',
                                iconProps: { iconName: 'PPMXSwitchUser' },
                                onClick: () => this.setState({ isReplacing: true })
                            } : undefined,
                            {
                                key: 'deleteRow',
                                name: `Remove from ${entityTypeLabelMap[entityType].singular}`,
                                style: { color: 'red' },
                                iconProps: { iconName: "Delete", style: { color: 'red' } },
                                onClick: () => this.setState({ isRemoving: true })
                            }
                        ].filter(notUndefined)}
                    controlSettings={isAssignments ? { ...controlSettings, timeType: controlSettings.assignments?.timeType } : controlSettings}
                    onSaveSettings={isAssignments ? this._saveAssignmentsSettings : onSaveSettings}
                    defaultSort={settings.orderBy?.length
                        ? { fieldName: settings.orderBy[0], direction: SortDirection.ASC }
                        : undefined}
                    onScaleChanged={(timelineChange) => {
                        onScaleChanged(entity.resourceIds, this._debouncedLoadUsages, timelineChange);
                        isAssignments && onScaleChanged(rowIds, this._debouncedLoadAssignments, timelineChange);
                    }
                    }
                />}
            {isAdding && <AddEntitiesDialog
                confirmButtonText="Add Resources"
                dialogContentProps={{
                    title: 'Add Resources',
                    subText: `Select resources to be added to the current ${entityTypeLabelMap[entityType].singular}`
                }}
                onDismiss={() => this.setState({ isAdding: false })}
                onComplete={_ => this._addResources(_)}
                renderEntitySelector={(onChanged) =>
                    <PersonPickerInput
                        multichoice
                        onChanged={(value) => value && onChanged((value as PersonInfo[]).map(_ => _.id))}
                        searchUrl="api/resource/findAllowed?resourcePlan=true"
                        noResultsFoundText={PersonPickerInput.NoResourceFound}
                        filter={{ exceptIds: entity.resourceIds }}
                        inputProps={{ placeholder: "Type to search", autoFocus: true }}
                    />}
            />}
            {isCreating && <ResourceCreationInResourcePlanControl
                onDismiss={() => this.setState({ isCreating: false })}
                entityType={entityType}
                timeframe={autoallocationTimeframe}
                onCreate={(name, layoutId, autoAllocate, startDate, finishDate) => {
                    const timeframe = this._getTimeframe();
                    this.props.actions.createResource(name, layoutId, convertToDateOnlyTimeframe(timeframe), autoAllocate, startDate, finishDate);
                }}
            />}
            {isReplacing && <ReplaceResourceDialog
                entityid={entity.id}
                entityType={entityType}
                isForResourcePlan={true}
                resource={(this._getSelectedEditable() as ResourcesListStore.Resource[])[0]}
                resourceIds={entity.resourceIds}
                onDismiss={() => this.setState({ isReplacing: false })}
                onReplaceResource={this._replaceResource}
            />}
            {isRemoving && <RemoveDialog dialogContentProps={{ title: `Remove Resource${this._getSelectedEditable().length > 1 ? 's' : ''}`, subText: this._getDeletionMessage() }}
                onClose={() => this.setState({ isRemoving: false })} onComplete={this._onRemove} />}
            {this.state.isOpenExtensionPanel && <ExtensionPanel
                entityType={EntityType.Resource}
                info={this.state.isOpenExtensionPanel}
                context={{ entityId: this.props.entity.id, entityType }}
                onDismiss={() => {
                    this.setState({ isOpenExtensionPanel: undefined });
                }} />}
            {isAllocateAccessRequest &&
                (this._canAllocateAccess()
                    ? <ConfirmationDialog
                        onDismiss={() => this.setState({ isAllocateAccessRequest: false })}
                        onYes={() => this._allocateAccessRequest()}
                        onNo={() => { }}
                        yesButtonProps={{ text: "Request" }}
                        noButtonProps={{ text: "Cancel" }}
                        dialogContentProps={{
                            title: 'Request Allocation Access',
                            subText: `Are you sure you want to request allocation access to this resource? \nAn email requesting to add you as an Allocation Manager for this resource will be sent to its Direct Manager(s) and Resource Manager(s): ${this._getUniqueDirectManagers(this._getSelectedReadOnly()).map(_ => _.fullName).join(', ')}.`
                        }} />
                    : <ConfirmationDialog
                        onDismiss={() => this.setState({ isAllocateAccessRequest: false })}
                        onYes={() => this.setState({ isAllocateAccessRequest: false })}
                        yesButtonProps={{ text: "Got it" }}
                        dialogContentProps={{
                            title: 'Allocation Access Cannot Be Requested',
                            subText: noneForResourceEntity(user.permissions.resource.resourcePlan)
                                ? "You can request allocation access only if you have the Manage Resource Planning permission. Currently, you have the Manage Resources permission. Allocation access cannot be granted to you by resource's Direct or Resource Manager.\nPlease contact your administrator regarding allocation access to this resource."
                                : 'This resource does not have a Direct Manager or Resource Manager assigned. Please contact your administrator regarding allocation access to this resource.'
                        }} />)
            }
        </>;
    }

    private _isAssignments(props: Props): boolean {
        return props.controlSettings.timelineGroup === 'assignments';
    }

    private _getRowIds(props: Props, assignments: Dictionary<ProjectAssignments> | undefined): string[] {
        return this._isAssignments(props)
            ? Object.keys(assignments ?? {})
            : props.entity.resourceIds;
    }

    private _getResources(props: Props, assignments: Dictionary<ProjectAssignments> | undefined) {
        return this._getRowIds(props, assignments).map(_ => props.resources.byId[_]).filter(notUndefined);
    }

    private _loadAssignments(props: Props) {
        this._debouncedLoadAssignments(this._getRowIds(props, this.state.assignments), convertToDateOnlyTimeframe(this._getTimeframe()));
    }

    private _loadProjectAssignments(timeframe: IScalableTimeframe) {
        const { entity } = this.props;
        this.setState({ isLoadingAssignments: true });
        const { promise, cancelTokenSource } = cancellableGet<Dictionary<ServerProjectAssignments>>(
            `api/${entity.isArchived ? 'archivedproject' : 'project'}/${entity.id}/resourceAssignments`,
            { start: timeframe.startDate, end: timeframe.endDate });
        this._assignmentsCancelTokenSource = cancelTokenSource;
        promise
            .then(data => {
                const resourceIds = Object.keys(data);
                const assignments = resourceIds.reduce<Dictionary<ProjectAssignments>>((acc, _) => ({ ...acc, [_]: toProjectAssignments(data[_]) }), {});
                const resources = this._getResources(this.props, assignments);
                this.setState({ assignments, resources, filteredResources: getFilteredResources(resources, this.props, this.props.entity.id) });

                const notLoaded = resourceIds.filter(_ => !this.props.resources.byId[_]?.usage);
                notLoaded.length && this.props.resourceActions.loadResourcesByIds(notLoaded, ResourceLoadingTypes.Calendar, undefined, true);
            })
            .catch(defaultCatch())
            .finally(() => this.setState({ isLoadingAssignments: false }));
    }

    private _saveAssignmentsSettings: OnUsageGridSaveSettings = (update, sendToServer) => this.props.onSaveSettings?.(update.type === 'TimeType'
        ? { ...update, parentSettingsPathKeys: [nameof<ControlSettings>('assignments'), ...update.parentSettingsPathKeys] }
        : update, sendToServer);

    private _canAllocateAccess(): boolean {
        const selected = this._getSelectedReadOnly();
        const item = selected[0] as ResourcesListStore.Resource;
        const { user } = this.props;
        return !noneForResourceEntity(user.permissions.resource.resourcePlan)
            && !!this._getDirectManager(item)?.length;
    }

    private _BuildAllocationRequestMenuItems(item: ResourcesListStore.Resource & IMaybeTotal): IContextualMenuItem[] {
        const { entity, hasResourceRoles, user } = this.props;
        if (item.isTotal
            || !entity.isEditable
            || !hasResourceRoles
            || (noneForResourceEntity(user.permissions.resource.resourceEntity)
                && noneForResourceEntity(user.permissions.resource.resourcePlan))) {
            return []
        }
        return [{
            key: 'allocationAccess',
            name: 'Request Allocation Access',
            iconProps: { iconName: 'PPMXResource' },
            onClick: () => this.setState({ isAllocateAccessRequest: true, selectedResourceIds: [item.id] })
        }];
    }

    private _isPlanEditable(item: ResourcesListStore.Resource & IMaybeTotal): boolean {
        return (item.isEditable || !!item.usage?.isEditable) && !item.isTotal;
    }

    private _getDirectManager(item: ResourcesListStore.Resource): PersonInfo[] | undefined {
        const result = item.attributes.DirectManager && item.attributes.ResourceManager
            ? item.attributes.DirectManager.concat(item.attributes.ResourceManager)
            : (item.attributes.DirectManager ?? item.attributes.ResourceManager);
        return result?.filter(_ => _.id !== this.props.user.id);
    }

    private _getUniqueDirectManagers(items: ResourcesListStore.Resource[]): PersonInfo[] {
        const directManagers: PersonInfo[] = [];
        items.forEach(_ => directManagers.push(...this._getDirectManager(_) ?? []));
        const uniqueDirectManagers = Array.from(
            new Map(directManagers.map(manager => [manager.id, manager])).values()
        );
        return uniqueDirectManagers;
    }

    private _onTimelineDisplayFieldsChange = (fields: string[]) => {
        const { sectionId, id } = this.props;
        const settingsKey = this._isAssignments(this.props) ? nameof<ISettings>('assignments') : nameof<ISettings>('timeline');
        this.props.actions.updateUIControl(sectionId, id, { [settingsKey]: { displayFields: fields } });
    }

    private _getTimeframe = () => {
        return { ...this.state.timeframe, ...getTimeframe(this.props.controlSettings.timeframe) };
    }

    private _getDeletionMessage = () => {
        const { entityType } = this.props.datacontext;
        const selection = this._rowSelection.getSelection();
        if (selection.length === 1) {
            return `Are you sure you want to remove resource "${(selection[0] as ResourcesListStore.Resource).attributes.Name}"\nfrom the ${entityTypeLabelMap[entityType].singular}?`;
        }

        return `Are you sure you want to remove selected resources\nfrom the ${entityTypeLabelMap[entityType].singular}?`;
    }

    private _allocateAccessRequest(): void {
        this.setState({ isAllocateAccessRequest: false });
        const selectedItems = this._getSelectedReadOnly().map(_ => (_ as ResourcesListStore.Resource).id);
        if (selectedItems.length) {
            post(`api/resourcePlan/SendAllocateAccessRequest`, { ids: selectedItems })
                .then(() => {
                    this.props.notificationsActions.pushNotification({ message: `Allocation access requst was successfully sent`, type: NotificationsStore.NotificationType.Success });
                })
        }
    }

    private _onRemove = () => {
        const selectedItems = this._getSelectedEditable().map(_ => (_ as ResourcesListStore.Resource).id);
        if (selectedItems.length) {
            const timeframe = this._getTimeframe();
            this.props.actions.removeResources(selectedItems, convertToDateOnlyTimeframe(timeframe));
        }
    }

    private _addResources = (resourceIds: string[] | undefined) => {
        if (resourceIds) {
            const timeframe = this._getTimeframe();
            this.props.actions.addResources(resourceIds, convertToDateOnlyTimeframe(timeframe));
            analytics.trackEvent("Add resource in resource plan", this.props.user, { count: resourceIds.length });
        }

        this.setState({ isAdding: false });
    }

    private _replaceResource = (newResourceIds: string[], keepRateOnReplace: boolean, sumUpPlanHours: boolean, sumUpActualHours: boolean, costRateTableId?: string) => {
        const prevResourceId = (this._getSelectedEditable() as ResourcesListStore.Resource[])[0]?.id;
        if (prevResourceId && newResourceIds?.[0]) {
            const timeframe = this._getTimeframe();
            this.props.actions.replaceResources(prevResourceId, newResourceIds[0], keepRateOnReplace, sumUpPlanHours,
                sumUpActualHours, convertToDateOnlyTimeframe(timeframe), costRateTableId);
        }

        analytics.trackEvent("Replace resource in resource plan", this.props.user, { keepRateOnReplace, sumUpPlanHours, sumUpActualHours });
    }

    private _getSelectedEditable = () => {
        const selected = this._rowSelection.getSelection() as (ResourcesListStore.Resource & IMaybeTotal)[];
        const selectedEditable = selected.filter(_ => this._isPlanEditable(_));
        return selectedEditable;
    }

    private _getSelectedReadOnly = () => {
        const selected = this._rowSelection.getSelection() as (ResourcesListStore.Resource & IMaybeTotal)[];
        const selectedReaOnly = selected.filter(_ => !_.usage?.isEditable && !_.isTotal);
        return selectedReaOnly;
    }

    private _getSelectionModeCommands(readOnly: boolean) {
        const { entityType } = this.props.datacontext;
        const hasEditable = !readOnly && this._getSelectedEditable().length > 0;

        return !hasEditable ? [] : [{
            key: 'deleteRow',
            name: `Remove from ${entityTypeLabelMap[entityType].singular}`,
            iconProps: { iconName: 'Delete' },
            onClick: () => this.setState({ isRemoving: true })
        }];
    }

    private _getCommands(readOnly: boolean, canCreate: boolean, isAssignments: boolean) {
        const commands: IContextualMenuItem[] = readOnly || isAssignments ? [] : [{
            key: 'addRow',
            name: 'Add Resource',
            iconProps: { iconName: 'Add' },
            onClick: () => this.setState({ isAdding: true })
        }, canCreate ?
            {
                key: 'createRow',
                name: 'Create Resource',
                iconProps: { iconName: 'Add' },
                onClick: () => this.setState({ isCreating: true })
            } : undefined,
        this.props.enableCalculatingResourcePlanActualsBasedOnReportedTime && !this.props.entity.isPrivate ? {
            key: 'syncReportedTime',
            name: 'Sync Actuals from Reported Time',
            iconProps: { iconName: 'Sync' },
            disabled: this.state.isResourcePlanActualsSyncInProgress,
            onClick: () => {
                this.props.projectsActions.runResourcePlanActualsRecalculation(this.props.entity.id);
                this.setState({ isResourcePlanActualsSyncInProgress: true });
            }
        } : undefined].filter(notUndefined);

        if (!readOnly) {
            const extensionsCommands = buildExtensionsMenuItem(this.props.extensions, (_) => this.setState({ isOpenExtensionPanel: _ }));
            const actionsCommand = buildActionsMenuItemWithItems(extensionsCommands);
            if (actionsCommand) {
                commands.push(actionsCommand);
            }
        }

        return commands;
    }
}

function mapStateToProps(state: ApplicationState, ownProps: OwnProps): StoreProps {
    const fields = state.fields[EntityType.Resource];
    const layouts = state.layouts[EntityType.Resource];

    const isReadOnlyMode = isInReadonlyMode(state.user, state.tenant, ownProps.entity);
    const timeTrackingSettings = state.tenant.timeTracking.globalSettings;

    return {
        resources: state.resources,
        isListLoading: state.resources.isListLoading,
        fields: fields.allIds.map(_ => fields.byId[_]),
        layouts: layouts.allIds.map(_ => layouts.byId[_]),
        canManageConfiguration: contains(state.user.permissions.common, CommonOperations.ConfigurationManage),
        fakeFields: state.views[EntityType.Resource].list.fakeFields,
        isFieldsLoading: fields.isLoading,
        user: state.user,
        extensions: ownProps.entityType ? findExtension(state.extensions, ownProps.entityType, ExtensionPageLocation.Actions, EntityType.Resource) : [],
        hasPortfolioManagement: Subscription.contains(state.tenant.subscription, PPMFeatures.PortfolioManagement),
        hasProjectManagement: Subscription.contains(state.tenant.subscription, PPMFeatures.ProjectManagement),
        hasResourceRoles: Subscription.contains(state.tenant.subscription, PPMFeatures.ResourceRoles),
        defaultCostRateTableId: getDefaultCostRateTable(state)?.id,
        fieldsStore: state.fields,
        costRateTables: state.costRateTables,
        canConfigureSelection: canResourceAnyRead(state.user.permissions.resource)
            && (ownProps.isViewSelected
                ? !ownProps.entity.isArchived && contains(state.user.permissions.common, CommonOperations.ConfigurationManage)
                : isReadOnlyMode || !!ownProps.entity.canConfigure),
        enableCalculatingResourcePlanActualsBasedOnReportedTime: Subscription.containsAny(state.tenant.subscription, [PPMFeatures.TimeTracking, PPMFeatures.TimeTrackingEnterprise]) &&
            timeTrackingSettings.newTimeTrackingEnabled &&
            timeTrackingSettings.calculateResourcePlanActualsBasedOnReportedTime &&
            EnableCalculatingResourcePlanActualsBasedOnReportedTime(state.tenant)
    };
}

function mergeActionCreators(dispatch: any): ActionProps {
    return {
        resourceActions: bindActionCreators(ResourcesListStore.actionCreators, dispatch),
        portfoliosActions: bindActionCreators(PortfoliosListStore.actionCreators, dispatch),
        programsActions: bindActionCreators(ProgramsListStore.actionCreators, dispatch),
        projectsActions: bindActionCreators(ProjectsListStore.actionCreators, dispatch),
        notificationsActions: bindActionCreators(NotificationsStore.actionCreators, dispatch),
        filtersActions: bindActionCreators(FiltersStore.actionCreators.forEntity(EntityType.Resource, FiltersStore.FilterKeys.ResourcePlan), dispatch)
    }
}

const getFilteredResources = (resources: ResourcesListStore.Resource[], props: Props, entityId: string) =>
    filter(resources, props.filter?.isItemVisible)
        .filter(_ => SearchFieldService.isItemVisible(props.search?.search, _, f => calculate(f, [_], [entityId], props.costRateTables),
            props.defaultCostRateTableId, props.fieldsStore));

const partialTotalsHint = "Totals reflect only the resources currently visible in the resource plan. Additional resources exist but are hidden by the applied filter/search.";

const renderPartialTotalsColumnHeader = (column: IColumn) => totalsFieldIds.includes(column.key)
    ? <span className="partial-totals-header">
        {column.name}
        <TooltipHost content={partialTotalsHint} className="text-hint" delay={TooltipDelay.zero}>
            <Icon iconName="Info" className="info-icon" onClick={e => e.stopPropagation()} />
        </TooltipHost>
    </span>
    : undefined;

const resourcePlanFilterIds = {
    all: 'a3f1c6d2-5e84-4b17-9c03-7d2e8f4a1b60',
    active: 'b7d2e9f4-1a63-4c58-8e07-3f6b2d9c4a15',
    inactive: 'c5e8b1a7-9d34-4f26-b71c-2a4d8e6f3b09'
};

const buildResourcePlanFilter = (id: string, name: string, isDefault: boolean): Metadata.IFilter<Metadata.BaseFilterValue> =>
    ({ id, name, value: {}, attributeNames: [], isBuiltIn: true, isDefault, isNotSaved: false });

const resourcePlanFilters = [
    buildResourcePlanFilter(resourcePlanFilterIds.all, 'All', true),
    buildResourcePlanFilter(resourcePlanFilterIds.active, 'Active', false),
    buildResourcePlanFilter(resourcePlanFilterIds.inactive, 'Inactive', false)
];

const isActive = (resource: ResourcesListStore.Resource) =>
    resource.attributes.Status === ResourcesListStore.ResourceStatus.Active;

const isActiveInEntity = (resource: ResourcesListStore.Resource, entityId: string) =>
    (calculateStateInEntity([resource], [entityId]) ?? ResourcesListStore.ResourceEntityState.Active)
        === ResourcesListStore.ResourceEntityState.Active;

type ResourcePlanFilterRule = Record<ResourceTimelineGroup,
    (resource: ResourcesListStore.Resource, entityId: string) => boolean>;

const resourcePlanFilterRules: Dictionary<ResourcePlanFilterRule> = {
    [resourcePlanFilterIds.active]: {
        resourcePlan: (resource, entityId) => isActive(resource) && isActiveInEntity(resource, entityId),
        assignments: isActive
    },
    [resourcePlanFilterIds.inactive]: {
        resourcePlan: (resource, entityId) => !isActive(resource) || !isActiveInEntity(resource, entityId),
        assignments: resource => !isActive(resource)
    }
};

const buildIsItemVisible = (entityId: string, timelineGroup: ResourceTimelineGroup) =>
    (_fields: Metadata.Field[], activeFilter: Metadata.IFilter<Metadata.BaseFilterValue> | undefined) =>
        (resource: ResourcesListStore.Resource) => {
            const rule = activeFilter && resourcePlanFilterRules[activeFilter.id];
            return !rule || rule[timelineGroup](resource, entityId);
        };

const useFilterProps = ({ entity, resources, fields, layouts, filtersActions, canManageConfiguration, defaultCostRateTableId,
    fieldsStore, history, location, controlSettings, onSaveSettings }: Props): WithFilterProps<ResourcesListStore.Resource> => {
    const planResources = React.useMemo(
        () => entity.resourceIds.map(_ => resources.byId[_]).filter(notUndefined),
        [entity.resourceIds, resources.byId]);

    const filterHelper = React.useMemo(
        () => new FilterHelper({ fields, layouts, resources: planResources, defaultCostRateTableId, fieldsStore }),
        [fields, layouts, planResources, defaultCostRateTableId, fieldsStore]);

    const { timelineGroup } = controlSettings;
    const isItemVisibleBuilder = React.useMemo(() => buildIsItemVisible(entity.id, timelineGroup), [entity.id, timelineGroup]);

    return {
        filterHelper,
        entityType: EntityType.Resource,
        entities: planResources,
        fields,
        filters: resourcePlanFilters,
        filtersActions,
        canManageConfiguration,
        isItemVisibleBuilder,
        history,
        location,
        controlSettings,
        onSaveSettings
    }
}

export default withRouter(connect(mapStateToProps, mergeActionCreators)(
    withFilter(withSearch(ResourcePlanControl), useFilterProps, FiltersStore.FilterKeys.ResourcePlan)));

const buildProjectTotalsFields = memoizeFunction((assignments: Dictionary<ProjectAssignments> | undefined) =>
    buildAssignmentsTotalFields(value => (resources: ResourcesListStore.Resource[]) => resources.reduce((sum, _) => {
        const totals = assignments?.[_.id]?.totals;
        return sum + (totals ? value(totals) : 0);
    }, 0)));

const buildAssignmentsSummaryCalculator = memoizeFunction((assignments: Dictionary<ProjectAssignments> | undefined) =>
    (startDate: Date, finishDate: Date, context: CellSummaryContext) =>
        calculateAssignmentsSummaryData(startDate, finishDate, context, assignments?.[context.resource.id]?.byDay));

export const buildResourcesGroup = (groupingEntity: IExtensibleEntity, entity: IExtensibleEntity, resources: ResourcesListStore.Resource[], entityType: EntityType,
    subitemBuilder?: (resource: ResourcesListStore.Resource, entity: IExtensibleEntity) => IRow): IRow => ({
        key: groupingEntity.id,
        entity: groupingEntity,
        subItems: resources.map<IRow>(resource => {
            const warnings: IWithWarnings | undefined = hasOutsideAllocation(resource.usage, entity.attributes.StartDate, entity.attributes.FinishDate, entity.id)
                ? { warnings: [allocationWarning(entityType)].concat(resource.warnings ?? []) }
                : undefined;

            resource = warnings ? { ...resource, ...warnings } : resource;
            resource = { ...resource, stateInEntity: { entityType, state: resource.usage?.byEntity[entity.id]?.attributes.stateInEntity } };

            return subitemBuilder?.(resource, entity) ?? {
                key: resource.id,
                entity: resource,
                markers: [],
                segments: []
            }
        }),
        markers: [],
        segments: []
    })